import _sfc_main from './UiRangeBar.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-ui-range-bar", attrs: { "role": "meter", "aria-valuenow": _vm.lastValue, "aria-valuemin": _vm.lowValue, "aria-valuemax": _vm.highValue } }, [_vm._t("root", function() {
    return [_vm._t("value(low)", function() {
      return [_vm.showLabels ? [_c("span", { staticClass: "fds-ui-range-bar__label" }, [_vm._t("value(low):content", function() {
        return [_vm.displayLowValue ? _c("span", [_vm._v(_vm._s(_vm.displayLowValue))]) : _c("span", [_vm._v(_vm._s(_vm.lowValue))])];
      })], 2)] : _vm._e()];
    }), _vm._t("wrapper", function() {
      return [_c("div", { staticClass: "fds-ui-range-bar__wrapper" }, [_vm._t("wrapper:point", function() {
        return [_c("span", { ref: "marker", staticClass: "fds-ui-range-bar__point", class: `fds-ui-range-bar__point--${_setup.pointerClassModifier}` })];
      }, null, { pointerClassModifier: _setup.pointerClassModifier })], 2)];
    }, null, { pointerClassModifier: _setup.pointerClassModifier }), _vm._t("value(high)", function() {
      return [_vm.showLabels ? [_c("span", { staticClass: "fds-ui-range-bar__label" }, [_vm._t("value(high):content", function() {
        return [_vm.displayHighValue ? _c("span", [_vm._v(_vm._s(_vm.displayHighValue))]) : _c("span", [_vm._v(_vm._s(_vm.highValue))])];
      })], 2)] : _vm._e()];
    })];
  }, null, { pointerClassModifier: _setup.pointerClassModifier })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/ui-range-bar/UiRangeBar.vue";
var UiRangeBar = __component__.exports;

export { UiRangeBar as default };
